// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@/redux/http';
import endPoints, { coreAPI } from '@/redux/constant';
import { customToast, isAllowedUploadFile, ALLOWED_UPLOAD_ERROR_MESSAGE } from '@/utils';

// Initial State
const initialState = {
  loading: false,
  error: null,
  isEditMediaKit: false,
  isBlurMediaKit: false,
  activeComponent: null,
  passwordGateRequest: null,
  mediaKitType: 'sample',
  isMediaKitProfessional: false,
  mandatoryFields: [],
  mandatorySections: {
    favFacts: {},
    cta: {},
    topVideos: {},
    brandPartners: {},
    contentPost1: {},
    contentPost2: {}
  },
  authenticatedFields: [],
  mediaKitStates: {
    intro: {},
    favFacts: null,
    topPosts: [],
    contentPost1: [],
    contentPost2: [],
    topInterest: null,
    brandPartners: null,
    audienceLocation: null,
    audienceGender: null,
    deliverables: null,
    cta: null,
    reviews: null,
    topVideos: null,
    rates: null,
    links: [],
    socials: null,
    mail: {
      mail: '',
      isUpdated: false
    },
    verificationBanner: null
  }
};

// SAVE MEDIA KIT INFO
export const saveMediaKitInfoAPIFn = createAsyncThunk(
  'mediakit/saveMediaKitInfoAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.saveDataForMediaKit}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// CONEVRT DUMMY MK TO REAL
export const convertDummyMKToRealAPIFn = createAsyncThunk(
  'mediakit/convertDummyMKToRealAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.convertDummyMKToReal}?UserId=${values?.userId}&InstagramHandle=${values?.instagramHandle}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET OVERALL RATING
export const getOverallRatingAPIFn = createAsyncThunk(
  'mediakit/getOverallRatingAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getOverallRating}?userId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// SAVE MEDIA KIT INFO
export const getMediaKitFavouriteFactsDetails = createAsyncThunk(
  'mediakit/getMediaKitFavouriteFactsDetails',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getSocialChannelDetails}/${values?.mediaKitId}?callingUserId=${values?.userId}&socilChannelName=${values?.socialChannelName}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET SOCIAL CHANNEL
export const getSocialChannel = createAsyncThunk(
  'mediakit/getSocialChannel',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getSocialChannel}/?callingUserId=${values?.userId}&mediaKitId=${values?.mediaKitId}&socialChannelName=${values?.channel}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Send Custom Deliverable API
export const sendCustomDeliverableAPIFn = createAsyncThunk(
  'mediakit/sendCustomDeliverableAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.sendCustomDeliverable}`,
        { ...values?.payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Send All Deliverables
export const sendAllDeliverableAPIFn = createAsyncThunk(
  'mediakit/sendAllDeliverableAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.sendAllDeliverables}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET Custom Rates
export const getCustomSocialRatesAPIFn = createAsyncThunk(
  'mediakit/getCustomSocialRatesAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getCustomSocialRates}?callingUserId=${values?.userId}&userId=${values?.userId}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET FAVORITE CONTENT
export const getFavoriteContentAPIFn = createAsyncThunk(
  'mediakit/getFavoriteContentAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.getInstaFavoriteContent}/${values?.userId}`);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Send Custom Rates API
export const sendCustomSocialRatesAPIFn = createAsyncThunk(
  'mediakit/sendCustomSocialRatesAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.sendCustomSocialRates}?callingUserId=${values?.userId}`,
        { ...values?.payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Send All Rates
export const sendAllRatesAPIFn = createAsyncThunk(
  'mediakit/sendAllRatesAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.sendAllRates}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET PERFORMANCE FACTS
export const getPerformanceFactsAPIFn = createAsyncThunk(
  'mediakit/getPerformanceFactsAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getPerformanceFact}/${values?.mediaKitId}?callingUserId=${values?.userId}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET CUSTOM FACTS
export const getCustomFactsAPIFn = createAsyncThunk(
  'mediakit/getCustomFactsAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getCustomFacts}/${values?.mediaKitId}?callingUserId=${values?.userId}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// SAVE CUSTOM FACTS
export const saveCustomFactsAPIFn = createAsyncThunk(
  'mediakit/saveCustomFactsAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.saveCustomFacts}?callingUserId=${values?.userId}`,
        { ...values?.payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

export const saveLinksAPIFn = createAsyncThunk(
  'mediakit/saveLinksAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.saveDataForSalesLinks}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPLOAD IMAGES FILE
export const uploadIntroImageAPIFn = createAsyncThunk(
  'mediakit/introUploadImage',
  async ({ file, onProgress }, { rejectWithValue }) => {
    try {
      if (!isAllowedUploadFile(file)) {
        return rejectWithValue(ALLOWED_UPLOAD_ERROR_MESSAGE);
      }

      const cleanName = file.name;
      const cleanFile = new File([file], cleanName, { type: file.type });
      const formData = new FormData();
      formData.append('file', cleanFile);

      const response = await axios({
        method: 'post',
        url: endPoints.uploadImage,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*'
        },
        data: formData,
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent?.total || 1)
          );
          if (onProgress) {
            onProgress(percentCompleted); // Execute the callback if provided
          }
        }
      });

      const imageUrl = response.data?.result?.imageUrl;
      return imageUrl?.includes('https://localhost')
        ? `${coreAPI}/uploads/ji5lDwuiz4.png`
        : imageUrl;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPLOAD VIDEO FILE
export const uploadIntroVideoAPIFn = createAsyncThunk(
  'mediakit/introUploadVideo',
  async ({ file, onProgress }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios({
        method: 'post',
        url: endPoints.uploadVideo,
        data: formData,
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / (progressEvent?.total || 1)
          );
          if (onProgress) {
            onProgress(percentCompleted);
          }
        }
      });

      return response.data?.result;
    } catch (error) {
      customToast.error(error?.message);
      return rejectWithValue(error?.response?.data);
    }
  }
);

// UPDATE SOCIAL CHANNELS
export const updateOrSaveSocialChannelsAPIFn = createAsyncThunk(
  'mediakit/socialChannels',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateOrSaveSocialChannelsURL}?callingUserId=${values?.userId}`,
        { ...values?.payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE EMAIL
export const updateEmailAPIFn = createAsyncThunk(
  'mediakit/updateEmailAPIFn',
  async (values, { rejectWithValue }) => {
    try {

      const { data } = await axios.post(
        `${endPoints.updateUserDisplayEmail}`,
        { ...values }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE FAVOURITE FACTS (facts + section visibility)
export const updateFavFactsAPIFn = createAsyncThunk(
  'mediakit/updateFavFactsAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateFavFacts}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE TOP INTERESTS (interests + section visibility)
export const updateTopInterestAPIFn = createAsyncThunk(
  'mediakit/updateTopInterestAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateTopInterest}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE DELIVERABLES / OFFERINGS (list + section visibility)
export const updateDeliverablesAPIFn = createAsyncThunk(
  'mediakit/updateDeliverablesAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateDeliverables}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE RATES (rates + section visibility)
export const updateRatesAPIFn = createAsyncThunk(
  'mediakit/updateRatesAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateRates}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE PROFILE NAME (full name)
export const updateProfileNameAPIFn = createAsyncThunk(
  'mediakit/updateProfileNameAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateProfileName}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE AGE RANGE (age + section visibility)
export const updateAgeRangeAPIFn = createAsyncThunk(
  'mediakit/updateAgeRangeAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateAgeRange}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE LOCATION (country + city)
export const updateLocationAPIFn = createAsyncThunk(
  'mediakit/updateLocationAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateLocation}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE TOP VIDEOS / FAVOURITE CONTENT (list + section visibility)
export const updateFavouriteContentAPIFn = createAsyncThunk(
  'mediakit/updateFavouriteContentAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateFavouriteContent}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE BRAND PARTNERS (list + section visibility)
export const updateBrandPartnerAPIFn = createAsyncThunk(
  'mediakit/updateBrandPartnerAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateBrandPartner}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE LINKS (list + section visibility)
export const updateLinksAPIFn = createAsyncThunk(
  'mediakit/updateLinksAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateLinks}`,
        { ...payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE PROFILE BIO (bio + description visibility)
export const updateProfileBioAPIFn = createAsyncThunk(
  'mediakit/updateProfileBioAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.updateProfileBio, {
        userId_chr: values?.userId_chr,
        bio_chr: values?.bio_chr,
        isDescriptionSectionToggle: values?.isDescriptionSectionToggle
      });
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.response?.data
      );
    }
  }
);

// UPDATE PROFILE PHOTO / VIDEO (intro profile content)
export const updateProfilePhotoAPIFn = createAsyncThunk(
  'mediakit/updateProfilePhotoAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.updateProfilePhoto, {
        userId_chr: values?.userId_chr,
        profilePicUrl_chr: values?.profilePicUrl_chr,
        profileVideoThumbnailUrl_chr: values?.profileVideoThumbnailUrl_chr,
        profileVideoUrl_chr: values?.profileVideoUrl_chr
      });
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.response?.data
      );
    }
  }
);

// Verify YoutubeChannel
export const verifyYoutubeChannelAPIFn = createAsyncThunk(
  'mediakit/verifyYoutubeChannelAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.verifyYoutubeChannelURL}?channelName=${values?.channelUserName}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Verify Instagram Channel — fetches basic details and normalizes to the shape handleSaveSocialChannels expects
export const verifyInstagramChannelAPIFn = createAsyncThunk(
  'mediakit/verifyInstagramChannelAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getInstagramUserBasicDetails}?handleName=${values?.channelUserName}`
      );
      return {
        ...data,
        result: {
          ...data.result,
          followers: data.result?.followers_count,
          noOfVideos: data.result?.media_count,
          engagementRate: data.result?.averageEngagementRatePerPost,
        }
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Verify PinterestChannel
export const verifyPinterestChannelAPIFn = createAsyncThunk(
  'mediakit/verifyPinterestChannelAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.verifyPinterestChannelURL}?userName=${values?.channelUserName}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// SAVE PERFORMANCE FACTS
export const savePerformanceFactsAPIFn = createAsyncThunk(
  'mediakit/savePerformanceFactsAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.savePerformanceFact}?callingUserId=${values?.userId}`,
        { ...values?.payload }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// GET SOCIAL CHANNEL POST URL
export const getSocialChannelPostURL = createAsyncThunk(
  'mediakit/getSocialChannelPostURL',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.getSocialChannelPostURL}?userName=${values?.userName}&socialChannel=${values?.socialChannel}&url=${values?.url}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// SAVE TOP CONTENT TOP VIDEOS
export const saveTopContentVideosAPIFn = createAsyncThunk(
  'mediakit/saveTopContentVideosAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.saveTopContentVideos}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// SAVE TOP CONTENT TOP VIDEOS
export const saveCollaborationBannerAPIFn = createAsyncThunk(
  'mediakit/saveCollaborationBannerAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.saveCollaborationBanner}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// UPDATE TOP POST
export const updateTopPostAPIFn = createAsyncThunk(
  'mediakit/updateTopPostAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.updateTopPost}?callingUserId=${values?.userId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE TOP POSTS SECTION VISIBILITY
export const toggleTopPostSectionAPIFn = createAsyncThunk(
  'mediakit/toggleTopPostSectionAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleTopPostSection, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE VERIFICATION BANNER SECTION VISIBILITY
export const toggleBannerSectionAPIFn = createAsyncThunk(
  'mediakit/toggleBannerSectionAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleBannerSection, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE AUDIENCE SECTION VISIBILITY
export const toggleAudienceSectionAPIFn = createAsyncThunk(
  'mediakit/toggleAudienceSectionAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleAudienceSection, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE REVIEW SECTION VISIBILITY
export const toggleReviewSectionAPIFn = createAsyncThunk(
  'mediakit/toggleReviewSectionAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleReviewSection, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE VERIFIED CHIP VISIBILITY
export const toggleVerifiedChipAPIFn = createAsyncThunk(
  'mediakit/toggleVerifiedChipAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleVerifiedChip, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE TOP SOCIAL SECTION VISIBILITY
export const toggleTopSocialSectionAPIFn = createAsyncThunk(
  'mediakit/toggleTopSocialSectionAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleTopSocialSection, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// TOGGLE BOTTOM SOCIAL SECTION VISIBILITY
export const toggleBottomSocialSectionAPIFn = createAsyncThunk(
  'mediakit/toggleBottomSocialSectionAPIFn',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.toggleBottomSocialSection, { ...payload });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// SAVE MEDIA KIT LIVE
export const saveMediaKitLiveAPIFn = createAsyncThunk(
  'mediakit/saveMediaKitLiveAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${endPoints.saveMediaKitLive}`, { ...values?.data });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response);
    }
  }
);

// DELETE TOP POST
export const deleteTopPostAPIFn = createAsyncThunk(
  'mediakit/deleteTopPostAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.deleteTopPost}?callingUserId=${values?.userId}&topPostId=${values?.topPostId}`,
        { ...values?.data }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);


export const verifyEmailAPIFn = createAsyncThunk(
  'mediakit/verifyEmailAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.verifyEmail}`,
        {
          email: values?.email,
          url: values?.url
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);


export const confirmEmailAPIFn = createAsyncThunk(
  'mediakit/confirmEmailAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endPoints.emailConfirmation}`,
        {
          email: values?.email,
          token: values?.token
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

export const updateUserEmailAPIFn = createAsyncThunk(
  'mediakit/updateUserEmailAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.updateUserEmail, {
        userId_chr: values?.userId,
        currentEmail_chr: values?.currentEmail,
        newEmail_chr: values?.newEmail
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

export const isEmailVerifiedAPIFn = createAsyncThunk(
  'mediakit/isEmailVerifiedAPIFn',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endPoints.isEmailVerified}/${values?.userId}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// MediaKit Slices
export const mediaKitSlice = createSlice({
  name: 'mediaKit',
  initialState,
  reducers: {
    requestSetPasswordGate: (state, action) => {
      state.passwordGateRequest = action.payload;
    },
    clearSetPasswordGate: (state) => {
      state.passwordGateRequest = null;
    },
    updateEditKit: (state, action) => {
      state.isEditMediaKit = action.payload;
    },
    updateBlurKit: (state, action) => {
      state.isBlurMediaKit = !state.isBlurMediaKit;
      state.activeComponent = action.payload;
    },
    resetBlurKit: state => {
      state.isBlurMediaKit = false;
      state.activeComponent = null;
    },
    updateActiveComponent: (state, action) => {
      state.activeComponent = action.payload;
    },
    updateMediaKitState: (state, action) => {
      const { key, value } = action.payload;
      if (Object.prototype.hasOwnProperty.call(state.mediaKitStates, key)) {
        state.mediaKitStates[key] = value;
      }
    },
    resetMediaKitState: state => {
      state.mediaKitStates = {
        intro: {},
        favFacts: null,
        topPosts: [],
        contentPost1: [],
        contentPost2: [],
        topInterest: null,
        brandPartners: null,
        audienceLocation: null,
        audienceGender: null,
        deliverables: null,
        cta: null,
        reviews: null,
        topVideos: null,
        rates: null,
        links: [],
        socials: null,
        mail: {
          mail: '',
          isUpdated: false
        },
        verificationBanner: null
      };
    },
    updateMandatoryFields: (state, action) => {
      state.mandatoryFields = action.payload;
    },
    updatedMandatorySections: (state, action) => {
      state.mandatorySections = action.payload;
    },
    resetMandatorySections: (state) => {
      state.mandatorySections = {
        favFacts: {},
        cta: {},
        topVideos: {},
        brandPartners: {}
      };
      state.mandatoryFields = [];
    },
    updateInstaAuthFields: (state, action) => {
      state.authenticatedFields = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(saveMediaKitInfoAPIFn.pending, state => {
        state.loading = true;
        state.error = null;
        state.mediaKit = null;
      })
      .addCase(saveMediaKitInfoAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.mediaKit = action.payload;
        state.error = null;
      })
      .addCase(saveMediaKitInfoAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.mediaKit = null;
      })
      .addCase(updateLocationAPIFn.pending, (state, action) => {
        const payload = action.meta?.arg;
        if (payload) {
          state.mediaKitStates.intro = {
            ...state.mediaKitStates.intro,
            userLocation: {
              ...state.mediaKitStates.intro?.userLocation,
              location: {
                ...state.mediaKitStates.intro?.userLocation?.location,
                country: payload.country_chr || null,
                city: payload.city_chr || null,
              },
              isLocationVisible: Boolean(payload.isCountryIncluded),
            }
          };
        }
      })
      .addCase(updateLocationAPIFn.fulfilled, (state, action) => {
        const payload = action.meta?.arg;
        if (payload) {
          state.mediaKitStates.intro = {
            ...state.mediaKitStates.intro,
            userLocation: {
              ...state.mediaKitStates.intro?.userLocation,
              location: {
                ...state.mediaKitStates.intro?.userLocation?.location,
                country: payload.country_chr || null,
                city: payload.city_chr || null,
              },
              isLocationVisible: Boolean(payload.isCountryIncluded),
            }
          };
        }
      });
  }
});

// Action Media-kit are generated for each case reducer function
export const {
  requestSetPasswordGate,
  clearSetPasswordGate,
  updateEditKit,
  updateBlurKit,
  resetBlurKit,
  updateActiveComponent,
  mediaKitDetails,
  updateMediaKitState,
  resetMediaKitState,
  updateMandatoryFields,
  resetMandatorySections,
  updatedMandatorySections,
  updateInstaAuthFields
} = mediaKitSlice.actions;

export default mediaKitSlice.reducer;
